module.exports = __webpack_public_path__ + "static/media/OurMission.7dde67a4.png";